"use client";

import { twMerge } from "tailwind-merge";

import HeroSection from "@/components/common/HeroSection";
import MiniCard from "@/components/common/MiniCard";
import CheckMarks from "@/components/common/CheckMarks";
import StatsCardsContainer from "@/components/StatCard";
import ImageCard from "@/components/common/ImageCard";
import SectionHeader from "@/components/common/SectionHeader";

import { cardData, points } from "@/constants/Data&AI";
import { ImageCardData } from "@/constants/UIUXData";

import { useIsDark } from "@/context/ThemeContext";

export default function DataAiPageClient() {
  const isdark = useIsDark();

  return (
    <div className="relative flex flex-col justify-center items-center   z-10">
      <section className="mx-5 md:mx-10 xl:mx-[100px] 3xl:mx-[150] sm:my-15">
        <HeroSection
          heading="MACHINE LEARNING SOLUTIONS"
          subHeading="Intelligent Systems Built for Smarter Decisions"
          paragraph="We transform business data into intelligent machine learning solutions that help organizations predict trends, automate decisions, and improve operational performance."
          headingStyles="text-[40px] mobile:text-[55px] sm:text-[80px] md:text-[95px] tablet:text-[120px] lg:text-[135px] xl:text-[160px] laptop:text-[170px] 3xl:text-[185px] 4xl:text-[215px] leading-[100%] text-center"
        />
      </section>

      <section className="flex flex-col items-center mx-5 md:mx-10 xl:mx-[100px] 3xl:mx-[150]">
        <SectionHeader
          title={"OUR MACHINE LEARNING SERVICES"}
          wrapperClassName="xl:mt-[133px] laptop:mt-0 xl:mb-0 px-0"
        />
        <div className="hidden tablet:grid grid-cols-3 w-full max-w-[2000px] gap-3 md:gap-5 xl:gap-[161px] xl:mt-[50px]">
          {cardData.map((item, index) => (
            <MiniCard
              key={index}
              icon={item.icon}
              heading={item.heading}
              paragraph={item.paragraph}
              // cardStyles="w-[306px] h-[449px]"
              paragraphStyles="leading-[28px] tracking-[0.02em]"
            />
          ))}
        </div>
        <div className="flex tablet:hidden flex-row flex-wrap justify-around w-full gap-3 sm:gap-5 mt-[50px] ">
          {cardData.map((item, index) => (
            <MiniCard
              key={index}
              icon={item.icon}
              heading={item.heading}
              paragraph={item.paragraph}
              paragraphStyles="leading-[28px] tracking-[0.02em] h-full"
              cardStyles="             
                w-full  
                mobile2:w-[264px]   
                sm:w-[290px]
                md:w-[334px]
                "
            />
          ))}
        </div>
      </section>

      <section
        className={twMerge(
          "flex flex-col items-center w-full mt-[50px] py-[25px] xl:py-[50px] px-5 md:px-10 xl:px-25",
          isdark ? "bg-[#2D2D2D]/50" : "bg-[#F2E4FE]/50",
        )}
      >
        <SectionHeader
          title={"WHY CHOOSE MACHINE LEARNING SOLUTIONS?"}
          description={
            "Unlock predictive intelligence through scalable machine learning systems designed for automation, analytics, and operational efficiency."
          }
          wrapperClassName="mt-0 md:mt-0 xl:mt-0 mb-0 md:mb-0 xl:mb-0"
          titleClassName="xl:text-[35px] px-0"
          descriptionClassName="xl:mt-[50px]"
        />
        <div className="flex flex-col md:flex-row justify-between items-center w-full max-w-[2000px] mt-[25px] xl:mt-[70px] gap-2">
          <CheckMarks points={points} />
          <StatsCardsContainer gridStyles="p-0" cardStyles="md:w-[150px]" />
        </div>
      </section>

      {/* <SectionHeader
        title={"latest projects"}
        description="A collection of latest data and AI works focused on enhancing user experiences and crafting modern digital interfaces."
        wrapperClassName="mt-[50px] mb-0 md:mb-0 xl:mb-0"
      /> */}
      {/* <div className="w-full px-5 md:px-10 xl:px-[100px]"> */}
      {/* Card slider for small screens */}
      {/* <div className="flex w-full mobile:hidden gap-4 overflow-x-auto snap-x snap-mandatory no-scrollbar">
          {ImageCardData.map((item, index) => (
            <div
              key={index}
              className="flex-shrink-0 basis-[80%] small:basis-[65%]"
            >
              <ImageCard
                key={index}
                image={item.image}
                topic={item.topic}
                text={item.text}
                sizes="(max-width: 480px) 80vw, 65vw"
              />
            </div>
          ))}
        </div> */}

      {/* <div className="hidden mobile:grid grid-cols-2 tablet:grid-cols-3 w-full max-w-[2000px] gap-x-6 2xl:gap-x-8 3xl:gap-x-10 4xl:gap-x-12 gap-y-2 mt-[30px] xl:mt-[70px] mx-auto">
          {ImageCardData.map((item, index) => (
            <ImageCard
              key={index}
              image={item.image}
              topic={item.topic}
              text={item.text}
              sizes="(max-width: 768px) 50vw, 33vw"
            />
          ))}
        </div> */}
      {/* </div> */}

      <section className="mx-5 md:mx-10 xl:mx-[100px] 3xl:mx-[150]">
        <SectionHeader
          title={"READY TO TURN DATA INTO INTELLIGENCE ?"}
          description={
            "We combine machine learning, scalable infrastructure, and intelligent analytics to build systems that help businesses operate smarter, faster, and more efficiently."
          }
          wrapperClassName="xl:mt-25 xl:mb-[50px] px-0"
          descriptionClassName="xl:mt-[50px]"
        />
      </section>
    </div>
  );
}
